import { env } from '@/env'
import { useDevSettings } from '@/hooks/useDevSettings'
import { authClient } from '@/lib/auth-client'

/**
 * Mirrors EmailService.resolveRecipient()'s divert precedence on the backend
 * (apps/platform-api/src/core/email/email.service.ts) so the message shown here never
 * claims a destination the backend wouldn't actually use.
 */
export function useEmailDivertNotice(): string | null {
  const isProd = env.VITE_DEPLOY_ENV === 'prod'
  const { data: session } = authClient.useSession()
  const { data: settingsResult } = useDevSettings({ enabled: !isProd })

  if (isProd) return null

  const settings = settingsResult?.data
  if (settings?.emailSandboxEnabled) {
    return "Emails are going to the Resend sandbox and won't be delivered. View them in the Resend dashboard."
  }

  if (settings?.emailDivertOverrideEnabled && settings.emailDivertOverrideTo) {
    return `You're in a non-production environment — this workspace redirects all outbound test email to ${settings.emailDivertOverrideTo}, not the real recipient.`
  }

  const userEmail = session?.user?.email
  if (userEmail) {
    return `You're in a non-production environment — this email will land in your own inbox (${userEmail}), not the recipient's.`
  }

  return "You're in a non-production environment — outbound email is redirected to a test inbox instead of the real recipient."
}
